/* ---------------------------------------------------------------------
   Quiz answers become memories.

   The home page's quiz cards and the category pages' quiz chips each end
   in a click: a pill, a photo, a chip that leads to a collection. Until
   now only the concern quiz and the size quiz left anything on the
   shopper's profile, so the profile's "What VRO remembers" showed the
   theme's example cards to everyone.

   This listens for that final click and files it on the personalization
   profile (assets/vro-personalization.js) as an "answer" facet:

     facets['answer@<key>'] = { q: question, a: answer, tag: 'Grooming' }

   One key per quiz, so answering again replaces the memory rather than
   adding a second. The card reads the question and tag off the markup
   (data-memory-question / data-memory-tag / data-memory-key), falling
   back to the heading it shows. sections/profile-memories.liquid turns
   each into a card via assets/profile-memories.js.

   Capture phase, so a chip that is a link is recorded before the page
   leaves. Two kinds of click are left alone: one that opens the modal
   quiz (its own last step saves the answer) and one that answers a facet
   in place (already a memory of its own).
--------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__vroQuizMemory) return;
  window.__vroQuizMemory = true;

  function api() {
    return (window.VroPersonalization && window.VroPersonalization.profile) || null;
  }
  function text(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }
  function slug(v) {
    return String(v || '').toLowerCase().replace(/\W+/g, '-').replace(/^-+|-+$/g, '');
  }
  function answerOf(btn) {
    var label = btn.querySelector('.quiz-tap-label');
    if (label) return text(label);
    var own = text(btn);
    if (own) return own;
    var img = btn.querySelector('img');
    return img ? String(img.getAttribute('alt') || '').trim() : '';
  }

  /* The card an option belongs to, and the key its answer is filed under. */
  function cardOf(btn) {
    return btn && btn.closest ? btn.closest('[data-memory-question], .quiz-teaser-card') : null;
  }
  function questionOf(card) {
    return card.getAttribute('data-memory-question')
      || card.getAttribute('data-quiz-title')
      || text(card.querySelector('.quiz-teaser-heading'));
  }
  function keyOf(card) {
    var q = questionOf(card);
    return card.getAttribute('data-memory-key') || (q ? slug(q) : '');
  }

  /* The option among `options` the shopper picked last time, or null. Read
     by the home page's quiz cards (sections/quiz-teaser.liquid) so an
     answered card opens answered, the same answer picked. */
  /* A guest's card is open this visit only. A card answered in this
     browser session reopens on its answer on every refresh; the next
     session (the tab or browser closed and opened again) finds it
     collapsed, asking the question again. The answer itself stays on the
     profile either way and keeps shaping the page.

     A signed-in shopper's card stays answered for good: tomorrow, next
     week, on the day the home page's daily rotation brings that card back
     round, and on their other devices once the profile syncs. The answer
     is filed under the card (the section id, or the quiz entry's handle),
     never under a date, and nothing here ages it. Only Retake asks again,
     and that is remembered on the answer itself (r: 1) so it holds across
     visits too — while the answer keeps shaping the page until a new one
     replaces it. */
  var OPEN_KEY = 'vro_quiz_open';
  function openKeys() {
    try { return JSON.parse(sessionStorage.getItem(OPEN_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function markOpen(key, on) {
    if (!key) return;
    try {
      var o = openKeys();
      if (on) o[key] = 1; else delete o[key];
      sessionStorage.setItem(OPEN_KEY, JSON.stringify(o));
    } catch (e) { /* storage unavailable: the card simply asks again */ }
  }
  function signedIn() {
    var p = api();
    return !!(p && p.customerId && p.customerId());
  }
  function forget(options) {
    var list = Array.prototype.slice.call(options || []);
    var card = list.length ? cardOf(list[0]) : null;
    if (!card) return;
    var key = keyOf(card);
    markOpen(key, false);
    var p = api();
    if (!key || !signedIn() || !p.getFacet || !p.setFacet) return;
    var entry = p.getFacet('answer@' + key);
    if (!entry || !entry.a || entry.r) return;
    var asked = {};
    Object.keys(entry).forEach(function (k) { asked[k] = entry[k]; });
    asked.r = 1;
    try { p.setFacet('answer@' + key, asked); } catch (e) { /* storage unavailable */ }
  }

  function savedOption(options) {
    var list = Array.prototype.slice.call(options || []);
    if (!list.length) return null;
    var card = cardOf(list[0]);
    var p = api();
    if (!card || !p || !p.getFacet) return null;
    var key = keyOf(card);
    if (!key) return null;
    var entry = p.getFacet('answer@' + key);
    if (!entry || !entry.a) return null;
    if (!openKeys()[key] && !(signedIn() && !entry.r)) return null;
    for (var i = 0; i < list.length; i++) {
      if (answerOf(list[i]) === entry.a) return list[i];
    }
    return null;
  }
  window.VroQuizMemory = { savedOption: savedOption, answerOf: answerOf, forget: forget };

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.quiz-teaser-pill-btn, [data-style-option]') : null;
    if (!btn) return;
    if (btn.hasAttribute('data-quiz-open')) return;
    if (btn.hasAttribute('data-vro-facet-option')) return;

    var card = cardOf(btn);
    if (!card) return;
    var question = questionOf(card);
    var answer = answerOf(btn);
    if (!question || !answer) return;

    var key = keyOf(card);
    var tag = card.getAttribute('data-memory-tag') || '';
    var p = api();
    if (!p || !p.setFacet) return;
    var entry = { q: question, a: answer, tag: tag };

    /* What the answer stands for on a product page (assets/vro-pdp-
       memory.js): the option's collection and hand-picked products, the
       heading the merchant wrote for PDPs, and the other options, so a PDP
       can offer Retake in place. Only where the quiz answers with a
       collection. */
    var root = btn.closest('.shopify-section') || card.parentNode || document;
    function panelFor(b) {
      var i = b.getAttribute('data-style-option');
      return i == null ? null : root.querySelector('[data-style-panel="' + i + '"]');
    }
    var panel = panelFor(btn);
    if (panel) {
      var c = panel.getAttribute('data-memory-collection') || '';
      var prods = (panel.getAttribute('data-memory-products') || '').split(',').filter(Boolean).slice(0, 12);
      if (c) entry.c = c;
      if (prods.length) entry.p = prods;
      var sub = card.getAttribute('data-memory-sub') || '';
      if (sub) entry.s = sub;
      var h = card.getAttribute('data-memory-pdp-heading') || '';
      if (h) entry.h = h;
      var seen = {};
      var opts = [];
      Array.prototype.forEach.call(card.querySelectorAll('[data-style-option]'), function (b) {
        var label = answerOf(b);
        if (!label || seen[label]) return;
        seen[label] = true;
        var pn = panelFor(b);
        var o = { a: label, c: (pn && pn.getAttribute('data-memory-collection')) || '' };
        /* Each option's own products too, so a Retake on a product page
           knows the new answer's shelf. A quiz picked from Content >
           Metaobjects usually answers with products alone, no collection. */
        var op = ((pn && pn.getAttribute('data-memory-products')) || '').split(',').filter(Boolean).slice(0, 8);
        if (op.length) o.p = op;
        opts.push(o);
      });
      if (opts.length) entry.o = opts;
    }
    try {
      p.setFacet('answer@' + key, entry);
    } catch (err) { /* storage unavailable; the click still does its job */ }
    markOpen(key, true);
  }, true);
})();
